<template>
  <div class="fill-height">
    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          ویرایش واحد
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.go(-1)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
              cols="12"
              sm="6"
              md="4">
            <v-autocomplete
                :items="buildingItems"
                v-model="buildingId"
                dense
                outlined
                @change="getUnitList"
                auto-select-first append-icon="fas fa-angle-down"
                label="انتخاب مجتمع"/>

          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="4">
            <v-autocomplete
                :items="getUnits"
                v-model="unitId"
                @change="search"
                dense
                outlined
                auto-select-first append-icon="fas fa-angle-down"
                label="انتخاب واحد"

            />

          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-card-text>
            <b-table responsive striped hover   stacked="md"  :items="dataList" :fields="fields">
              <template v-slot:cell(type)="row">
                <span v-if="row.item.owner">مالک</span>
                <span v-if="row.item.owner && row.item.tenant">/</span>

                <span v-if="row.item.tenant">مستاجر</span>
              </template>

              <!-- سلول‌های عادی -->
              <template v-slot:cell(fullName)="data">
                <span v-if="editingIndex !== data.index">{{ data.item.fullName }}</span>
                <v-text-field v-else dense outlined :error-messages="getError('fullName')" v-model="model.fullName"/>

              </template>
              <template v-slot:cell(userName)="data">
                <span v-if="editingIndex !== data.index">{{ data.item.userName }}</span>
                <v-text-field v-else dense outlined :error-messages="getError('mobile')" v-model="model.mobile"/>
              </template>

              <!-- سلول اکشن‌ها (دکمه‌ها) -->
              <template v-slot:cell(actions)="row">

                <!--                <div v-if="editingIndex !== row.index">-->
                <!-- حالت عادی -->
                <v-btn v-if="editingIndex !== row.index" depressed class="mr-1" small color="primary"
                       @click="editRow(row.item, row.index)">
                  ویرایش
                </v-btn>
                <!--                </div>-->
                <div v-else>
                  <!-- حالت ویرایش -->
                  <v-btn depressed class="mr-1" small color="success" @click="openDialog">
                    ثبت
                  </v-btn>
                  <v-btn depressed class="mr-1" small color="error" @click="closed()">
                    لغو
                  </v-btn>

                </div>


              </template>
              <template v-slot:cell(t)="row">
                <v-checkbox v-if="editingIndex !== row.index && row.item.owner"
                            label="مستاجر دارد"
                            dense
                            color="primary"
                            class="action-checkbox"
                            @change="addRow(row.item,row.index)"
                            v-model="hasTenant"
                ></v-checkbox>

              </template>
            </b-table>
          </v-card-text>
        </v-row>
        <v-dialog v-model="dialogStatus"
                  persistent
                  max-width="400px">
          <div class="fill-height">

            <v-card class="fill-height">
              <v-card-subtitle>انتخاب تاریخ استقرار</v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <date-picker v-if="dialogStatus" placeholder="تاریخ استقرار" v-model="model.dateText"
                                 color="#3b5694" clearable
                                 auto-submit>
                    </date-picker>
                    <span style="color: red" v-if="getError('dateText')" v-text="getError('dateText')"/>

                  </v-col>
                </v-row>
                <v-divider class="p-0 m-0"/>
                <v-card-actions dir="ltr">

                  <v-btn
                      @click="save"
                      small
                      depressed
                      color="primary"
                      class=" p-1 m-1"
                      type="submit"
                      :loading="loading"
                  >
                    ذخیره
                  </v-btn>
                  <v-btn
                      @click="closed"
                      small
                      depressed
                      color="error"
                      class=" p-1 m-1"

                  >
                    لغو
                  </v-btn>
                </v-card-actions>
              </v-card-text>

            </v-card>
          </div>
        </v-dialog>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Unit_se from "@/views/define/unitEditRequest/UnitEditRequest_se";

export default {
  data() {
    return {
      buildingItems: [],
      unitList: [],
      dataList: [],
      userItems: [],
      buildingId: '',
      unitId: '',
      hasTenant: false,
      isTemp: false,
      dialogStatus: false,
      loading: false,
      bindingErrors: [],
      fields: [
        {label: '', key: 't',},
        {label: 'نوع', key: 'type'},
        {label: 'نام', key: 'fullName'},
        {label: 'شماره موبایل', key: 'userName'},
        {label: 'عملیات', key: 'actions'},
      ],
      editingIndex: -1, // ایندکس سطری که در حال ویرایش است
      model: {},
    }
  },
  computed: {
    getUnits() {
      return this.unitList
    }
  },
  methods: {
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    editRow(item, index) {
      let type = item.owner ? 'مالک' : 'مستاجر'
      Unit_se.edit(item.id, type).then(response => {
        this.model = response.data
        this.editingIndex = index;
      })
    },
    addRow(item, index) {
      if (this.hasTenant && !this.isTemp) {
        Unit_se.new(item.id).then(response => {
          this.model = response.data
          this.dataList.push(this.model)
          this.editingIndex = ++index;
        })
      } else if (!this.hasTenant && this.isTemp) {
         this.remove()
      } else if (!this.isTemp) {
        this.dataList.pop()
        this.editingIndex = -1;
      }
    },

    getUnitList(val) {
      this.clear_()
      Unit_se.getUnits(val).then(response => {
        this.unitList = response.data.unitList
        this.userItems = response.data.userItems
      })
    },
    fillDataItems() {
      this.model = {}
      Unit_se.page().then(response => {
        this.buildingItems = response.data.buildingList
        if (this.buildingItems.length > 0) {
          this.buildingId = this.buildingItems[0]
          this.getUnitList(this.buildingId)
        }
      });
    },
    clear_(){
      this.model ={}
      this.editingIndex = -1
      this.dataList = []
    },
    search() {
      this.clear_()
      Unit_se.search(this.buildingId, this.unitId).then(response => {
        this.dataList = response.data.results
        this.hasTenant = response.data.hasTenant
        this.isTemp = response.data.hasTenant
      });
    },
    remove() {
      this.$confirm("آیا  مستاجر حذف شود؟","توجه")
          .then(isDestroyed => isDestroyed && Unit_se.remove(this.buildingId, this.unitId).then(response => {
            if (response && response.status === 200) {
              this.$snack({type: 'success'})
              this.closed()
            }
      }));
    },

    openDialog() {
      if (!this.model.fullName) {
        this.bindingErrors.push({fieldName: 'fullName', name: 'fullName', message: ["الزامیست"]})
      }
      if (!this.model.mobile) {
        this.bindingErrors.push({fieldName: 'mobile', name: 'mobile', message: ["الزامیست"]})
      }
      if (this.bindingErrors.length === 0) {
        this.dialogStatus = true
      }
    },
    save() {
      this.loading = true
      Unit_se.save(this.model).then(response => {
        this.loading = false
        if (response && response.status === 200) {
          this.$snack({type: 'success'})
          this.closed()
        } else if (response && response.response.status === 400) {
          this.loading = false
          this.bindingErrors = response.response.data;
        }
      })
    },
    closed() {
      this.bindingErrors = []
      this.dialogStatus = false;
      this.editingIndex = -1;
      this.search()
    }

  },
  created() {
    this.fillDataItems();
  }
}
</script>
<style>

</style>